import { Box } from "@mui/material";
import PrivacyComponent from "../../components/account/privacy";
function PrivacyPage() {
  return <Box>{<PrivacyComponent />}</Box>;
}

export default PrivacyPage;
